import { render, staticRenderFns } from "./highlight-toggle.vue?vue&type=template&id=db1be792"
import script from "./highlight-toggle.vue?vue&type=script&lang=js"
export * from "./highlight-toggle.vue?vue&type=script&lang=js"
import style0 from "./highlight-toggle.vue?vue&type=style&index=0&id=db1be792&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports